export default __webpack_public_path__ + "static/media/register_worker.be92e7c8.png";